import React from 'react';
import PropTypes from 'prop-types';
import HomeRowWrapper from './HomeRowWrapper';
import DimensionsRow from './DimensionsRow';

const DimensionsHomeRow = (props) => {
    const { dimensions, labelTextId, labelDefaultMessage, subtext, className, loading } = props;

    return dimensions.length ? (
        <HomeRowWrapper
            labelTextId={labelTextId}
            labelDefaultMessage={labelDefaultMessage}
            subtext={subtext}
            className={className}
        >
            <DimensionsRow dimensions={dimensions} loading={loading} />
        </HomeRowWrapper>
    ) : null;
};

DimensionsHomeRow.propTypes = {
    labelTextId: PropTypes.string,
    labelDefaultMessage: PropTypes.string,
    subtext: PropTypes.string,
    className: PropTypes.string,
    dimensions: PropTypes.array,
    loading: PropTypes.bool
};

export default DimensionsHomeRow;
